export default __webpack_public_path__ + "images/5G.0a2061f.png";